export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/Home-638d9a327a175694118e68b0ca0bddc6.png";